import React, { Component } from 'react'
import { NavLink, RouteComponentProps } from 'react-router-dom'
import { AxiosInstance } from 'axios'
import { withTranslation, WithTranslation } from 'react-i18next'
import { getmeta, Meta, methodNames } from '../common'
import * as FileSaver from 'file-saver'
import { Breadcrumb, Button, Container, Dimmer, Grid, Icon, List, ListContent, ListHeader, ListIcon, ListItem, Loader, Message, Modal, Segment } from 'semantic-ui-react'
import './FileView.css'

interface FilesState {
    loading: boolean,
    errorMsg: string,
    contents: string
}

interface FilesProps extends WithTranslation, RouteComponentProps {
    meta: Meta,
    http: AxiosInstance,
    path: string
}

class Files extends Component<FilesProps, FilesState> {

    state = {
        loading: false,
        errorMsg: '',
        contents: ''
    }

    getFile(path: string) {
        const { t, meta } = this.props
        this.setState({loading: true})
        const url = 'files/'+path
        this.props.http.get(url)
            .then(response => {
                const data = response.data.data
                this.setState({contents: data, errorMsg: '', loading: false})
            }).catch(err => {
                if (err.response) {
                    this.setState({errorMsg: err.response.data.message||err.response.data, loading: false, contents: ''})
                } else {
                    this.setState({errorMsg: t('Unknown error'), loading: false, contents: ''})
                }
            })
    }

    componentDidMount(): void {
        this.getFile(this.props.path)
    }

    componentDidUpdate(prevProps: Readonly<FilesProps>, prevState: Readonly<FilesState>, snapshot?: any): void {
        const { loading } = this.state
        if (loading) return
        if (this.props.path !== prevProps.path)
            this.getFile(this.props.path)
    }

    render() {
        const { t, path, history, meta } = this.props
        const { contents, loading } = this.state
        const fileName = path.replace(/^.*\//,'')

        const saveFile = (contents: string, fileName: string) => {
            const fileType = 'text/plain;charset=UTF-8;'
            const rdata = new Blob([contents], {type: fileType})
            FileSaver.saveAs(rdata, fileName)
        }

        return(
            <>{this.state.errorMsg ?
              (
                <Container>
                    <Message error icon='exclamation triangle' header={t('Error')} content={this.state.errorMsg}/>
                </Container>
              )
              :
              (
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <Button type="button" color="blue" icon="download" onClick={()=>saveFile(contents, fileName)}/>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <Segment className='file-contents'>
                                { loading? 
                                    <Dimmer active inverted><Loader inverted/></Dimmer> 
                                :
                                    <pre className='wrap'>{ contents }</pre>
                                }
                            </Segment>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
              )}
            </>
        )
    }
}

export default withTranslation()(Files)